import { useAuthentication } from '@app/src/context/AuthenticationContext'
import { getProviderTypeFromSolution } from '@app/src/utils/solution'
import type { ProviderType } from '@app/src/wf-constants'

export default (): ProviderType => {
  const { scope } = useAuthentication()
  return getProviderTypeFromSolution(scope.solution)
}
